<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
        payload.domain = Endpoints.domain;//nao remover, usado para apresentar a foto
        let company = payload.$session.get('user').companyUser.company._id;
        payload.filters.company = company
        payload.filter();

        
    },
    methods:{
        filter: function(){
            let state = this;
            state.items = [];
            
            Request.do(state, 'POST', Request.getDefaultHeader(state), state.filters, `${Endpoints.systemUsers.filter}`,
            (response)=>{//SUCCESS CALLBACK
                state.items = response.results;

                if(state.items.length > state.totalTruckers && state.totalTruckers > 0){
                    state.newTrucker = true;
                }
                state.totalTruckers = state.items.length;
                // console.log(state.items);
            },
            (error)=>{//ERROR CALLBACK
            });
        },
         showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, x, y, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: x,
                y: y,
                time: time
            }
            return config
        },

        showMesage: function(result){
            if(result == 2){
                location.reload();
                this.flashMessage.error(
                    this.configMessage(this.$t('string.msg.listTrucker.register.title.rejected'), this.$t('string.msg.listTrucker.register.message.rejected'), 'top left', 0, 630, 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.listTrucker.register.message.rejected')),
                            destroyed: this.clearText()
                        })
            }
            else if(result == 1){
                location.reload();
                this.flashMessage.success(
                    this.configMessage(this.$t('string.msg.listTrucker.register.title.success'), this.$t('string.msg.listTrucker.register.message.success'), 'top left', 0, 630, 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.listTrucker.register.message.success')),
                            destroyed: this.clearText()
                        })
            } 
        },
        selectItem: function(item){
            this.item = item;
            setTimeout(async function(){
                this.$('#modalCNH').modal('show');
            }, 100);
        },
        load(){
            this.time = (this.filter());
                if(this.newTrucker){
                    this.playSound();
                    this.newTrucker = false;
               }
        },
        playSound: function(){
            var audio = new Audio('http://soundbible.com/mp3/Elevator Ding-SoundBible.com-685385892.mp3');
            audio.play();
        },
     
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
